import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation resources
import enCommon from "../locales/en/common.json";
import enAbout from "../locales/en/about.json";
import enFaq from "../locales/en/faq.json";
import enHome from "../locales/en/home.json";
import enTrust from "../locales/en/trust.json";
import enSeo from "../locales/en/seo.json";
import enTestimonials from "../locales/en/testimonials.json";
import enPrivacy from "../locales/en/privacy.json";
import enFieldNotes from "../locales/en/field-notes.json";
import enTermsOfUse from "../locales/en/terms-of-use.json";
import enInvoicingPaymentTerms from "../locales/en/invoicing-payment-terms.json";
import enUsecase from "../locales/en/usecase.json";
import enLaw from "../locales/en/law.json";

import esCommon from "../locales/es/common.json";
import esAbout from "../locales/es/about.json";
import esFaq from "../locales/es/faq.json";
import esHome from "../locales/es/home.json";
import esTrust from "../locales/es/trust.json";
import esSeo from "../locales/es/seo.json";
import esTestimonials from "../locales/es/testimonials.json";
import esPrivacy from "../locales/es/privacy.json";
import esFieldNotes from "../locales/es/field-notes.json";
import esTermsOfUse from "../locales/es/terms-of-use.json";
import esInvoicingPaymentTerms from "../locales/es/invoicing-payment-terms.json";
import esUsecase from "../locales/es/usecase.json";
import esLaw from "../locales/es/law.json";

const resources = {
  en: {
    common: enCommon,
    about: enAbout,
    faq: enFaq,
    home: enHome,
    trust: enTrust,
    seo: enSeo,
    testimonials: enTestimonials,
    privacy: enPrivacy,
    "field-notes": enFieldNotes,
    "terms-of-use": enTermsOfUse,
    "invoicing-payment-terms": enInvoicingPaymentTerms,
    usecase: enUsecase,
    law: enLaw,
  },
  es: {
    common: esCommon,
    about: esAbout,
    faq: esFaq,
    home: esHome,
    trust: esTrust,
    seo: esSeo,
    testimonials: esTestimonials,
    privacy: esPrivacy,
    "field-notes": esFieldNotes,
    "terms-of-use": esTermsOfUse,
    "invoicing-payment-terms": esInvoicingPaymentTerms,
    usecase: esUsecase,
    law: esLaw,
  },
};

// Only initialize if not already initialized
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "en",
      lng: "en", // Set default language explicitly
      debug: true, // Enable debug mode to see what's happening

      // Language detection options - simplified for static generation
      detection: {
        order: ["path", "localStorage", "navigator", "htmlTag"],
        caches: ["localStorage"],
        lookupFromPathIndex: 0,
        checkWhitelist: true,
      },

      interpolation: {
        escapeValue: false, // React already does escaping
      },

      // Namespace configuration
      defaultNS: "common",
      ns: [
        "common",
        "about",
        "faq",
        "home",
        "trust",
        "seo",
        "testimonials",
        "privacy",
        "field-notes",
        "terms-of-use",
        "invoicing-payment-terms",
        "usecase",
        "law",
      ],

      // Static generation compatibility
      react: {
        useSuspense: false,
      },

      // Ensure translations are loaded synchronously
      initImmediate: false,

      // Load all namespaces for the current language
      load: "all",

      // Preload all namespaces
      preload: ["en", "es"],
    });
}

export default i18n;
